module.exports = __webpack_public_path__ + "static/media/highRiskUsers.8dff585c.svg";